import { render, staticRenderFns } from "./RoleManagerView.vue?vue&type=template&id=15d25189&scoped=true"
import script from "./RoleManagerView.vue?vue&type=script&lang=js"
export * from "./RoleManagerView.vue?vue&type=script&lang=js"
import style0 from "./RoleManagerView.vue?vue&type=style&index=0&id=15d25189&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d25189",
  null
  
)

export default component.exports